<template>
  <el-dialog title="设置用户标签" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
             :close-on-press-escape="false">
      <el-form size="small" :model="form">

          <el-form-item label="标签" :label-width="formLabelWidth">
              <el-input v-model="form.label" autocomplete="off"></el-input>
          </el-form-item>
          
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible">取 消</el-button>
          <el-button type="primary" @click="editUser" :loading="loading">确 定</el-button>
      </div>
  </el-dialog>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
      data() {
          return {
              /*左边长度*/
              formLabelWidth: '120px',
              /*是否显示*/
              loading: false,
              dialogVisible: false,
      
          };
      },
      props: ['open_add','form'],
      created() {
          this.dialogVisible = this.open_add;
      },
      methods: {
          
  
          editUser(){
              let self = this;
              self.loading = true;
              let params = self.form;
              UserApi.label(params,true)
                  .then(data => {
                      self.loading = false;
                      if (data.code == 1) {
                          self.$message({
                              message: '恭喜你，标签设置成功',
                              type: 'success'
                          });
                          self.dialogFormVisible(true);
                      }
                  })
                  .catch(error => {
                      self.loading = false;
                  });
          },
          /*关闭弹窗*/
          dialogFormVisible(e) {
              if (e) {
                  this.$emit('closeDialog', {
                      type: 'success',
                      openDialog: false
                  })
              } else {
                  this.$emit('closeDialog', {
                      type: 'error',
                      openDialog: false
                  })
              }
          }
      }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Label.vue